import { initializeApp } from 'firebase/app'
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth'

/* Public client config for smallscaleminers-b75d5. These are not secrets -
 * access control lives in Firebase Auth, the RTDB rules and the Flask backend.
 * Values can still be overridden per-environment via Vite env vars. */
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? 'AIzaSyDQiMpKmXwRJDrbhYi8VAohxmIlU5WffrI',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'smallscaleminers-b75d5.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'smallscaleminers-b75d5',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? 'smallscaleminers-b75d5.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_SENDER_ID ?? '857264332813',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '1:857264332813:web:663fa2cf4ac0dc9f7db544',
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL ?? 'https://smallscaleminers-b75d5-default-rtdb.firebaseio.com',
}

export const firebaseApp = initializeApp(firebaseConfig)
export const auth = getAuth(firebaseApp)

/* Survive a refresh. The Flask __session cookie is the real credential for API
 * calls, but keeping the Firebase session lets us re-exchange silently when the
 * cookie expires before the user does. */
void setPersistence(auth, browserLocalPersistence)
